var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    [
      _vm.status === null || _vm.status === "failed"
        ? _c("FileUpload", {
            ref: "upload",
            attrs: { multiple: true, accept: _vm.accept },
            on: { input: _vm.upload }
          })
        : _c(
            "Box",
            _vm._l(Object.values(_vm.filesMap), function(file) {
              return _c("UIInput", {
                key: file.name,
                style: `background: linear-gradient(to left, white ${100 -
                  file.uploadedPercentage}%, antiquewhite ${100 -
                  file.uploadedPercentage}%); margin-bottom: 16px;`,
                attrs: { type: "text", disabled: true, value: file.name }
              })
            }),
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }